import { IEquatable } from "../Utils/ObjUtils";
import { ByteArrayUtils } from "../Utils/ByteArrayUtils";
import { ObjUtils } from "../Utils/ObjUtils";
import { IpVersion, IpAddress } from "./IpAddress";

export enum NetMaskType { IpAddress, Length };

export class IpNetMask implements IEquatable {	

	public static Create(maskAddr: IpAddress): IpNetMask {
		if (maskAddr == null)
			return null;

		return new IpNetMask(maskAddr);
	}

	public static CreateFromVersion(ipVer: IpVersion, maskLen: number): IpNetMask {
		if (maskLen < 0)
			return null;

		if (ipVer == IpVersion.IPv4 && maskLen > 32)
			return null;

		if (ipVer == IpVersion.IPv6 && maskLen > 128)
			return null;

		return new IpNetMask(null, ipVer, maskLen);
	}

	private _maskType: NetMaskType;
	public get MaskType(): NetMaskType {
		return this._maskType;
	}

	private _maskAddress: IpAddress;
	public get MaskAddress(): IpAddress {
		return this._maskAddress;
	}

	private _maskLength: number;
	public get MaskLength(): number {
		return this._maskLength;
	}

	public get IpVersion(): IpVersion {
		return this.MaskAddress.IpVersion;
	}

	/// <summary>
	/// Number of host bits for this netmask
	/// </summary>
	public get HostLength(): number {
		return this.MaskAddress.Bytes.length * 8 - this.MaskLength;
	}

	constructor(maskAddr?: IpAddress, ipVer?: IpVersion, maskLen?: number) {
		if (maskAddr) {
			this._maskType = NetMaskType.IpAddress;
			this._maskAddress = maskAddr;
			var hostBits = ByteArrayUtils.CountLeastSignificantZeroBits(maskAddr.Bytes);
			this._maskLength = maskAddr.Bytes.length * 8 - hostBits;
		} else {
			var bytes = new Uint8Array((ipVer == IpVersion.IPv4) ? 4 : 16);
			ByteArrayUtils.SetMostSignificantBits(bytes, maskLen);

			this._maskType = NetMaskType.Length;
			this._maskAddress = IpAddress.CreateFromBytes(bytes);
			this._maskLength = maskLen;
		}
	}

	public ApplyMask(ip: IpAddress):IpAddress {
		var result = ip.Clone();
		var resultBytes = result.Bytes;
		var maskBytes = this.MaskAddress.Bytes;

		for (var i = 0; i < resultBytes.length; ++i)
			resultBytes[i] &= maskBytes[i];

		return result;
	}

	public Clone(): IpNetMask {
		var clonedMask = new IpNetMask(this.MaskAddress.Clone());
		return clonedMask;
	}

	public toString(): string {
		switch (this.MaskType) {
			case NetMaskType.Length:
				return this.MaskLength.toString();
			case NetMaskType.IpAddress:
				return this.MaskAddress.toString();
			default:
				return "";
		}
	}

	public ToString(): string {
		return this.toString();
	}

	public Equals(obj: any) : boolean {
		if (obj == null)
			return false;
		if (!(obj instanceof IpNetMask))
			return false;
		var other = <IpNetMask>obj;
		if (this.MaskType != other.MaskType)
			return false;
		return this.MaskAddress.Equals(other.MaskAddress);
	}

	public GetHashCode() : number {
		return (ObjUtils.GetHashCode(this.MaskType) ^ this.MaskAddress.GetHashCode());
	}
}
